module.exports = __webpack_public_path__ + "img/wklad.b1f401fb.png";